import { IGeneralSettings } from "shared/api/api";
import { SharedAppState } from "shared/state/store.shared";

export function ExtractLocationCode(locationCode: string | undefined) {
	if (locationCode) {
		const code = locationCode.split(':')[0];
		if (code) {
			return code;
		}
	}
	return null;
}